// @ts-nocheck

import React, {useEffect, useState} from 'react';
import Header from '@components/header/Header';
import arrowIcon from '@assets/images/icons/arrow-ico.svg';
import callIcon from '@assets/images/icons/call.png';
import messageIcon from '@assets/images/icons/message.png';
import docIcon from '@assets/images/icons/doc-ico.svg';
import {useHistory, useLocation, useParams} from 'react-router-dom';
import {IGaugeChartData, IProcessMaps} from '@src/types';
import ConsumptiongaugeChart from '@components/module-components/consumtionGaugeChart/ConsumptionGaugeChart';
import StepMap from '@components/StepMap/StepMap';
import {formatImgUrl, formatShortDescription, getLengthDescription, getParams, translate} from '@src/helpers';
import StepMedia from '@components/StepMedia/StepMedia';
import {useDispatch, useSelector} from 'react-redux';
import {Translations} from '@constants/translate';
import '@pages/StepDetail/step-detail.scss';
import {getBrandInfo, getProcessEco, getProcessInfo, getProcessMedia} from '@api/Common';
import Footer from '@components/footer/Footer';
import _ from "lodash-es";
import {
  getNestedConnectedOrders,
  groupByProcessPosition,
  sortObjectProperties
} from "@components/module-components/POSMap/helper";
import logo from "@components/module-components/logo/Logo";

interface IParams {
  code: string,
  position: string
}

interface IProcessSummary {
  process_manufacturer_name: string
  process_manufacturer_description: string | null
  process_manufacturer_phone: string | null
  process_manufacturer_email: string | null
  process_location: string
  process_name: string
  process_scanned_date: string
  process_scanned_by: string
  process_position: number
}

interface ICerti {
  certificate_name: string,
  certificate_validity: string,
  certificate_field: string,
  certificate_document: string
}

interface AttachedFilesInterface {
  name: string,
  path: string
}

const LIMITDESCRIPTION = 20;

const StepDetail = () => {
  const langData = useSelector((state: any) => state.currentLanguage) as any;
  const navigatorHelp = useSelector((state: any) => state.navigatorHelper) as any;

  const [brandInfo, setBrandInfo] = useState({} as any);
  const defaultSummary: IProcessSummary = {
    process_manufacturer_name: '',
    process_manufacturer_description: '',
    process_manufacturer_phone: '',
    process_manufacturer_email: '',
    process_location: '',
    process_name: '',
    process_scanned_date: '',
    process_scanned_by: '',
    process_position: 0
  };

  const {
    order = '',
    process = '',
    brand = '',
    tab = ''
  } = getParams();

  const defaultGaugeChartData = {
    water: {
      reduce_increase: 100,
      grade: "A",
      recorded: 0
    },
    carbon: {
      reduce_increase: 100,
      grade: "A",
      recorded: 0
    },
    energy: {
      reduce_increase: 100,
      grade: "A",
      recorded: 0
    }
  } as IGaugeChartData;

  const defaultMap: IProcessMaps = {
    marker: {lat: '', lng: ''},
    name: ''
  };

  const defaultMedia = {
    video: '',
    imgCarousel: [] as string[]
  };

  const defaultAttachedFiles: AttachedFilesInterface[] = [];

  const defaultCerti: ICerti[] = [];

  let {code} = useParams() as IParams;
  let history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();

  const [summaryData, setSummaryData] = useState({...defaultSummary});
  const [gaugeData, setGaugeData] = useState({...defaultGaugeChartData});
  const [mapData, setMapData] = useState({...defaultMap});
  const [certiData, setCertiData] = useState([...defaultCerti]);
  const [attachedFilesData, setAttachedFilesData] = useState([...defaultAttachedFiles]);
  const [mediaData, setMediaData] = useState({...defaultMedia});
  const [isExpandDes, setExpandDes] = useState(false);
  const [isShowEco, setShowEco] = useState(0);
  const [processes, setProcesses] = useState([] as Array<any>);

  const getAllProcesses = (arr, key) => {
    console.log('arr', arr)
    let groups: Array<any> = [];

    arr.forEach((item) => {
      for (let keys in item) {
        if (keys === key) {
          let prs = item[key];
          if (item) {
            const {
              b2c_url,
              order_code: process_name,
              order: process_id,
              order_position_b2c: process_position_b2c,
              order_location: process_location,
              order_long: process_long,
              order_lat: process_lat,
            } = item;
            if (b2c_url &&
              process_name &&
              process_id &&
              process_position_b2c &&
              process_location &&
              process_long &&
              process_lat) {
              prs.unshift({
                b2c_url,
                process_id,
                process_lat,
                process_location,
                process_long,
                process_name,
                process_position_b2c
              })
            }
          }
          groups.push(prs)
        } else if (Array.isArray(item[keys])) {
          getAllProcesses(item[keys], key)
        }
      }
    })

    return groups
  }

  useEffect(() => {
    (async () => {

      const {data: brandData} = await getBrandInfo(brand);
      if (brandData) {
        setBrandInfo(brandData);
      }
      const {data: dataSummary} = await getProcessInfo(order, process);
      setSummaryData({
        ...summaryData,
        ...dataSummary
      });

      /**
       * Copied from PosMap.tsx
       */
      let ordersList: Array<any> = [];
      let orderedProcesses: Array<any> = []

      if (_.size(dataSummary) > 0) for (let item of [dataSummary]) {
        let connected_orders: any = _.cloneDeep(item?.connected_orders)
        orderedProcesses = [...orderedProcesses, ...getNestedConnectedOrders(connected_orders), item]
        if (_.size(orderedProcesses) > 0) {
          ordersList = [...orderedProcesses]
        }
      }

      _.forEach(ordersList, (process, index) => {
        let t: any = {};
        process.custom_order = index + 1 + ""
        process.longitude = process.process_long;
        process.latitude = process.process_lat
        t.process_position_b2c = process.process_position_b2c
        if (!_.has(process, 'process_position_b2c')) {
          process.process_position_b2c = process.process_position || ""
        }
        process = sortObjectProperties(process)
        return process;
      })

      setProcesses(groupByProcessPosition(ordersList))

      const gcData = {} as any;
      const {data: dataEco} = await getProcessEco(order, process);
      if (dataEco) {
        dataEco?.eco_score?.map((item: any) => {
          if (item) {
            const {type, ...rest} = item;
            gcData[type] = {
              ...rest
            }
          }
          return true;
        });

        setShowEco(dataEco.eco_visible);

        setGaugeData({
          ...gcData
        });

        setMapData({
          ...mapData,
          marker: {
            lat: dataEco.lat,
            lng: dataEco.long
          },
          name: dataEco.name
        });
      }
      const {data: dataMedia} = await getProcessMedia(order, process);
      if (dataMedia) {
        if (dataMedia.process_certificates)
          setCertiData([
            ...dataMedia.process_certificates
          ]);

        if (dataMedia.attached_files)
          setAttachedFilesData([
            ...dataMedia.attached_files
          ]);

        let mediaResoureces = {};

        if (dataMedia.process_images) {
          mediaResoureces = {
            ...mediaResoureces,
            imgCarousel: [
              formatImgUrl(dataMedia.process_images, 1),
              formatImgUrl(dataMedia.process_images, 2),
              formatImgUrl(dataMedia.process_images, 3),
              formatImgUrl(dataMedia.process_images, 4)
            ]
          }
        }

        if (dataMedia.process_video) {
          mediaResoureces = {
            ...mediaResoureces,
            video: dataMedia.process_video
          }
        }

        setMediaData({
          ...mediaData,
          ...mediaResoureces
        });
      }
    })();

  }, [langData.lang]);

  useEffect(() => {
    // console.log("navigatorHelp", navigatorHelp)
  }, [navigatorHelp]);

  return (
    <>
      <Header header={brandInfo} haveMenu={false}/>
      <main>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="infor-detail">
                <div className="infor-detail-left d-flex justify-content-sm-start">
                  <div className="media">
                    <button className="btn-arrow d-flex align-self-center"
                            onClick={() => {
                              history.push({
                                pathname: navigatorHelp.previous.pathname,
                                search: navigatorHelp.previous.search
                              })
                            }}><img className="arrow" src={arrowIcon} alt="Arrow"/>
                    </button>
                    <div className="media-body">
                      <div className="media-body-info text-center">
                        <h5 className="step-number mt-0">{navigatorHelp.query.process_position || summaryData.process_position}</h5>
                        <p className="step-name">{summaryData.process_name}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="infor-detail-center">
                  <div className="infor-center">
                    <div className="row">
                      <div className="col pl-2 pl-lg-3">
                        <div className="infor-item infor-item-first">
                          <p>{translate(langData.localize, Translations["FIP.COMMON.MANUFACTURER"])}<br/>
                            <b>{summaryData.process_manufacturer_name}</b></p>
                        </div>
                        <div className="infor-item">
                          <p>{translate(langData.localize, Translations["FIP.COMMON.LOCATION"])}<br/>
                            <b>{summaryData.process_location}</b></p>
                        </div>
                        <div className="infor-item">
                          <p>{translate(langData.localize, Translations["FIP.BRAND.STEP.SCANNED_BY"])}<br/>
                            <b>{summaryData.process_scanned_by}</b>
                            {/* <span className="blockchain-status-holder">
                              <img src="../assets/images/icons/check_ok.png" />
                            </span> */}
                          </p>
                        </div>
                        <div className="infor-item">
                          <p>{translate(langData.localize, Translations["FIP.COMMON.DATE_TIME"])}<br/>
                            <b>{summaryData.process_scanned_date}</b></p>
                        </div>
                        <div className="infor-item-last">
                          {summaryData.process_manufacturer_phone &&
                              <a className={`btn btn-call${summaryData.process_manufacturer_phone ? '' : ' disabled'}`}
                                 href={`tel:${summaryData.process_manufacturer_phone}`}><img
                                  src={callIcon} alt="fone"/></a>}

                          {summaryData.process_manufacturer_email &&
                              <a className={`btn btn-call ml-2${summaryData.process_manufacturer_email ? '' : ' disabled'}`}
                                 href={`mailto:${summaryData.process_manufacturer_email}?subject=Fibretrace_Contact_Order_Number=${code}`}><img
                                  src={messageIcon} alt="message"/></a>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {
                summaryData.process_manufacturer_description && <div className="infor-des">
                      <div className={`infor-des-content${isExpandDes ? ' infor-des-content--expand' : ''}`}>
                        {(isExpandDes || getLengthDescription(summaryData.process_manufacturer_description) <= LIMITDESCRIPTION) &&
                            <div className="infor-des-content-block"
                                 dangerouslySetInnerHTML={{__html: summaryData.process_manufacturer_description}}/>}
                        {!isExpandDes && getLengthDescription(summaryData.process_manufacturer_description) > LIMITDESCRIPTION &&
                            <div
                                className="infor-des-content-block">{formatShortDescription(summaryData.process_manufacturer_description, LIMITDESCRIPTION)}...</div>}
                      </div>

                  {
                    getLengthDescription(summaryData.process_manufacturer_description) > LIMITDESCRIPTION &&
                      <div className="infor-des-toggle">
                                            <span className="short-des"
                                                  onClick={() => setExpandDes(!isExpandDes)}>{isExpandDes ? translate(langData.localize, Translations["LABEL.SHOW_LESS"]) : translate(langData.localize, Translations["LABEL.SHOW_MORE"])}</span>
                      </div>
                  }
                  </div>
              }
            </div>
          </div>
        </div>

        <div className="container-fluid order-detail">
          {isShowEco === 1 && <div className="container p-0 mb-5">
              <ConsumptiongaugeChart gaugeData={gaugeData} className="col-xs-12 col-lg-5 col-xl-4"/>
          </div>
          }
          <div className="map">
            <div id="map-canvas">
              {(mapData.marker.lat && mapData.marker.lng) &&
                  <StepMap {...mapData} processes={processes}/>
              }
            </div>
            <span className="bg-overlay"></span>
          </div>

          <div className="container">
            <StepMedia medias={mediaData} name={summaryData.process_manufacturer_name}/>
          </div>
        </div>
        {
          certiData.length > 0 &&
            <div className="container container-cer">
                <h4 className="title-cer">{translate(langData.localize, Translations["FIP.COMMON.CERTIFICATES"])}</h4>
                <div className="table-certificates">
                    <table className="table">
                        <thead>
                        <tr>
                            <th>{translate(langData.localize, Translations["FIP.BRAND.STEP.TABLE.NAME"])}</th>
                            <th>{translate(langData.localize, Translations["FIP.BRAND.STEP.TABLE.VALIDITY"])}</th>
                            <th>{translate(langData.localize, Translations["FIP.BRAND.STEP.TABLE.FIELD"])}</th>
                            <th>{translate(langData.localize, Translations["FIP.BRAND.STEP.TABLE.DOCUMENT"])}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                          certiData?.map((certi: ICerti) =>
                            <tr key={`${certi.certificate_name}-${certi.certificate_validity}`}>
                              <td>{certi.certificate_name}</td>
                              <td>{certi.certificate_validity}</td>
                              <td>{certi.certificate_field}</td>
                              <td><a href={`${certi.certificate_document}`} target="_blank"
                                     rel="noopener noreferrer"><img src={docIcon} alt="message"/></a></td>
                            </tr>
                          )
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        }
        {
          attachedFilesData.length > 0 &&
            <div className="container container-cer">
                <h4 className="title-cer">{translate(langData.localize, Translations["FIP.BRAND.ORDER.TABLE.FILES"])}</h4>
                <div className="table-certificates">
                    <table className="table">
                        <thead>
                        <tr>
                            <th>{translate(langData.localize, Translations["FIP.BRAND.STEP.TABLE.NAME"])}</th>
                            <th>{translate(langData.localize, Translations["FIP.BRAND.STEP.TABLE.DOCUMENT"])}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                          attachedFilesData?.map((file: AttachedFilesInterface) =>
                            <tr key={`${file.name}`}>
                              <td>{file.name}</td>
                              <td><a href={`${file.path}`} target="_blank" rel="noopener noreferrer"><img
                                src={docIcon} alt="message"/></a></td>
                            </tr>
                          )
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        }
      </main>
      <Footer footer={brandInfo}/>
    </>
  );
}

export default StepDetail;
